import React from "react";
import WorkplaceSearchHeader from "./SearchHeader";
import MobileResultPreview from "./components/MobileResultPreview";


const SharedSearchResultInterface = (props) => {
    return <>
        <WorkplaceSearchHeader totalResults={props.totalResults}
                               currentViewIsMap={props.currentViewIsMap}
                               isSearchFormVisible={props.isSearchFormVisible}
                               setCurrentViewIsMap={props.setCurrentViewIsMap}
                               setIsSearchFormVisible={props.setIsSearchFormVisible} />

        {props.isSearchFormVisible && <MobileResultPreview totalResults={props.totalResults}
                             setIsSearchFormVisible={props.setIsSearchFormVisible} />
        }
    </>
}

export default SharedSearchResultInterface;
